module.exports = __webpack_public_path__ + "img/originalkinesio.abf496a9.jpg";